export default __webpack_public_path__ + "ddeb0eceedc9a4721c665c687245bede.svg";